import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem } from '@finam/web-ui-kit';
import TextField from '../TextField';
import useAutocomplete from './useAutocomplete';

var EmailField = function EmailField(_a) {
  var value = _a.value,
      props = __rest(_a, ["value"]);

  var hints = useAutocomplete(value);
  return _jsx(TextField, Object.assign({}, props, {
    value: value,
    menuItems: hints.map(function (hint) {
      return _jsx(MenuItem, Object.assign({
        value: hint
      }, {
        children: hint
      }), hint);
    }),
    DropDownProps: hints.length ? undefined : {
      open: false
    }
  }));
};

export default EmailField;